import { LocalShipping, ThumbDown, ThumbUp } from "@material-ui/icons";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import CreatedByField from "../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { Chip } from "@material-ui/core";
import * as React from "react";
import { formatDate } from "../../../../Helper/MomentHelper";

const AlternatePnStatusChip = ({ requestAlternatePn }) => {
  let icon, text;
  const [altPn, setAltPn] = React.useState(requestAlternatePn?.[0] ?? null);

  React.useEffect(() => {
    setAltPn(requestAlternatePn?.[0] ?? null);
  }, [requestAlternatePn]);

  if (altPn !== undefined) {
    if (altPn?.status === RequestStatus.ReplacementPnOffered) {
      icon = <LocalShipping />;
      text = [
        RequestStatus[RequestStatus.ReplacementPnOffered],
        " by ",
        <CreatedByField record={altPn} link={false} source="createdBy" />,
        " ",
        formatDate(altPn?.createdDate),
      ];
    } else if (altPn?.status === RequestStatus.ReplacementPnAccepted) {
      icon = <ThumbUp />;
      text = [
        RequestStatus[RequestStatus.ReplacementPnAccepted],
        " by ",
        <CreatedByField record={altPn} link={false} source="updatedBy" />,
        " ",
        formatDate(altPn?.updatedDate),
      ];
    } else if (altPn?.status === RequestStatus.ReplacementPnRejected) {
      icon = <ThumbDown />;
      text = [
        RequestStatus[RequestStatus.ReplacementPnRejected],
        " by ",
        <CreatedByField record={altPn} link={false} source="updatedBy" />,
        " ",
        formatDate(altPn?.updatedDate),
      ];
    }
  }

  return <Chip key={999989} color="primary" variant="outlined" label={text} icon={icon} />;
};

export default AlternatePnStatusChip;
